import {useFeatureServices} from '../use-feature-services';
import {inspector} from './inspector/inspector';
import packageJson from '../../package.json';
import {useEffect} from 'react';

export const useInspectFa = (): void => {
  const inspectFaService = useFeatureServices()['inspect-fa-service'];
  useEffect(() => {
    inspectFaService?.registerInstanceByFa(inspector, packageJson.version);

    return () => {
      inspectFaService?.unregisterInstanceByFa();
    };
  }, [inspectFaService]);
};
